import { useOnboardingStepViewed } from '@/hooks/use-analytics'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/onboarding/territory')({
  component: TerritoryRedirect,
})

function TerritoryRedirect() {
  useOnboardingStepViewed('territory_redirect')
  const navigate = useNavigate()
  useEffect(() => {
    navigate({ to: '/onboarding/company-territory', replace: true })
  }, [navigate])
  return <></>
}
